<mainpanel [Title]="'Form Channel'" [hideSearchBox]="true" [hideSearchDropdown]="true">
    <div actions>
        <a role="button" class="btn btn-danger btn-fill btn-lg text-white me-3" routerLink="/menu/channel/list">Cancel</a>
        <button role="button" class="btn btn-success btn-fill btn-lg text-white" (click)="Submit()" [disabled]="form.SubDomain == '' || form.ClientIDGuid == '' || form.ClientSecretGuid == '' ">Submit</button>
    </div>
    <div content>
      <div class="container-fluid mt-5">

        <form #f="ngForm" name="form">
          <div class="row">
            <div class="col-md-6">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-label-group">
                        <input type="text" id="SubDomain" placeholder="SubDomain (Ex: Brand.dealpos.net)"
                               class="form-control tall" [(ngModel)]="form.SubDomain"
                               name="SubDomain" matTooltip="SubDomain" #SubDomain="ngModel"
                               required />
                        <label for="SubDomain">SubDomain (Ex: Brand.dealpos.net)</label>
                      </div>
                      <div class="alert alert-danger"
                           *ngIf="SubDomain.invalid && (SubDomain.dirty || SubDomain.touched)">
                        <span>SubDomain is required!</span>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-label-group">
                        <input type="text" id="ClientIDGuid" placeholder="Client ID Guid (Ex: 9821546b-xxxx-xxxx-xxxx)"
                               class="form-control tall" [(ngModel)]="form.ClientIDGuid"
                               name="ClientIDGuid" matTooltip="ClientIDGuid" #ClientIDGuid="ngModel"
                               required />
                        <label for="ClientIDGuid">Client ID Guid (Ex: 1021546b-xxxx-xxxx-xxxx)</label>
                      </div>
                      <div class="alert alert-danger"
                           *ngIf="ClientIDGuid.invalid && (ClientIDGuid.dirty || ClientIDGuid.touched)">
                        <span>ClientID is required!</span>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-label-group">
                        <input type="text" id="ClientSecretGuid" placeholder="Client Secret Guid (Ex: 9821546b-xxxx-xxxx-xxxx)"
                               class="form-control tall" [(ngModel)]="form.ClientSecretGuid"
                               name="ClientSecretGuid" matTooltip="ClientSecretGuid" #ClientSecretGuid="ngModel"
                               required />
                        <label for="ClientSecretGuid">Client Secret Guid (Ex: 9821546b-xxxx-xxxx-xxxx)</label>
                      </div>
                      <div class="alert alert-danger"
                           *ngIf="ClientSecretGuid.invalid && (ClientSecretGuid.dirty || ClientSecretGuid.touched)">
                        <span>Client Secret Guid is required!</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-label-group">
                        <input type="text" id="LoginID" placeholder="LoginID (Ex: Admin)"
                               class="form-control tall" [(ngModel)]="form.LoginID"
                               name="LoginID" matTooltip="LoginID" LoginID="ngModel"
                               required />
                        <label for="LoginID">LoginID</label>
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-label-group">
                        <input type="password" id="Password" placeholder="Password (Ex: xxxx)"
                               class="form-control tall" [(ngModel)]="form.Password"
                               name="Password" matTooltip="Password" Password="ngModel"
                               required />
                        <label for="Password">Password</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
</mainpanel>
